import ClubOwnerTypeContextProvider from './state/clubOwnerType/ClubOwnerTypeContextProvider';
import BusinessEntityContextProvider from './state/businessEntity/BusinessEntityContextProvider';
import ClubInactiveReasonContextProvider from './state/clubInactiveReason/ClubInactiveReasonContextProvider';
import OrgRoleMultiselectContextProvider from './state/orgRoleMultiselect/OrgRoleMultiselectContextProvider';
import ClubRegistrationNewContextProvider from './state/clubRegistrationNew/ClubRegistrationNewContextProvider';
import OrganizationTypeContextProvider from './state/organizationType/OrganizationTypeContextProvider';
import UsasClubStaffContextProvider from './state/clubStaff/UsasClubStaffContextProvider';
import LscBoardMemberContextProvider from './state/lscBoardMembers/LscBoardMemberContextProvider';
import LegalEntityTypeContextProvider from './state/legalEntity/LegalEntityTypeContextProvider';
import MeetFormatContextProvider from './state/meetFormat/MeetFormatContextProvider';
import MeetSanctionConfigurationContextProvider from './state/meetSanctionConfiguration/MeetSanctionConfigurationContextProvider';

import OrganizationContextProvider from '@usas/ui-web/state/organization/OrganizationContextProvider';
import LscContextProvider from '@usas/ui-web/state/lsc/LscContextProvider';
import CourseContextProvider from '@usas/ui-web/state/course/CourseContextProvider';
import PoolDimensionsContextProvider from '@usas/ui-web/state/poolDimensions/PoolDimensionsContextProvider';
import PoolConfigurationContextProvider from '@usas/ui-web/state/poolConfiguration/PoolConfigurationContextProvider';
import OrgRoleStaffRoleHierarchyContextProvider from '@usas/ui-web/state/orgRoleStaffRoleHierarchy/OrgRoleStaffRoleHierarchyContextProvider';
import MeetClassificationContextProvider from '@usas/ui-web/state/meet/meetClassification/MeetClassificationContextProvider';
import BPMeetClassificationContextProvider from '@usas/ui-web/state/meet/blockPartyMeetClassification/BPMeetClassificationContextProvider';
import MeetSoftwareContextProvider from '@usas/ui-web/state/meet/meetSoftware/MeetSoftwareContextProvider';
import ClubAffiliationTypeContextProvider from '@usas/ui-web/state/clubAffiliationType/ClubAffiliationTypeContextProvider'
import VendorContextProvider from '@usas/ui-web/state/vendor/VendorContextProvider';
import RouteCodeValueContextProvider from '@usas/ui-web/state/routeCode/RouteCodeValueContextProvider';
import LscLifeMemberNewContextProvider from '@usas/ui-web/state/memberAdministration/lscLifeMemberNew/LscLifeMemberNewContextProvider';
import OfferingTypesContextProvider from '@usas/ui-web/state/offeringTypes/OfferingTypesContextProvider';


const AppStateContextProviders = ({ children }) => {
  return (
    <ClubRegistrationNewContextProvider>
      <OrganizationTypeContextProvider>
        <OfferingTypesContextProvider>
          <LegalEntityTypeContextProvider>
            <LscLifeMemberNewContextProvider>
              <OrgRoleMultiselectContextProvider>
                <OrganizationContextProvider>
                  <UsasClubStaffContextProvider>
                    <LscBoardMemberContextProvider>
                      <LscContextProvider>
                        <CourseContextProvider>
                          <PoolDimensionsContextProvider>
                            <PoolConfigurationContextProvider>
                              <VendorContextProvider>
                                <ClubOwnerTypeContextProvider>
                                  <BusinessEntityContextProvider>
                                    <ClubInactiveReasonContextProvider>
                                      <OrgRoleStaffRoleHierarchyContextProvider>
                                        <MeetClassificationContextProvider>
                                          <BPMeetClassificationContextProvider>
                                            <MeetSoftwareContextProvider>
                                              <MeetFormatContextProvider>
                                                <MeetSanctionConfigurationContextProvider>
                                                  <ClubAffiliationTypeContextProvider>
                                                    <RouteCodeValueContextProvider>
                                                      {children}
                                                    </RouteCodeValueContextProvider>
                                                  </ClubAffiliationTypeContextProvider>
                                                </MeetSanctionConfigurationContextProvider>
                                              </MeetFormatContextProvider>
                                            </MeetSoftwareContextProvider>
                                          </BPMeetClassificationContextProvider>
                                        </MeetClassificationContextProvider>
                                      </OrgRoleStaffRoleHierarchyContextProvider>
                                    </ClubInactiveReasonContextProvider>
                                  </BusinessEntityContextProvider>
                                </ClubOwnerTypeContextProvider>
                              </VendorContextProvider>
                            </PoolConfigurationContextProvider>
                          </PoolDimensionsContextProvider>
                        </CourseContextProvider>
                      </LscContextProvider>
                    </LscBoardMemberContextProvider>
                  </UsasClubStaffContextProvider>
                </OrganizationContextProvider>
              </OrgRoleMultiselectContextProvider>
            </LscLifeMemberNewContextProvider>
          </LegalEntityTypeContextProvider>
        </OfferingTypesContextProvider>
      </OrganizationTypeContextProvider>
    </ClubRegistrationNewContextProvider >
  );
};

export default AppStateContextProviders;